import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DEFAULT_BOX_SHADOW,
  PRIMARY_BACKGROUND,
  WMS_FA_PEMBELIAN,
} from "App/constants";

import { Paper } from "@material-ui/core";
import { Title } from "App/Component/ui";

import { FormPembelian } from "./ui";
import { FormProvider } from "./context/FormContext";
import { RenderListPembelian, getPembelianItemByPembelianId } from "./helpers";
import { RESET_STATE_PEMBELIAN_BARANG } from "./ui/DataBarang/helpers";
import { isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function InputPembelian({ data, menu, changeParentData }) {
  const classes = useStyles();

  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <Title title={"Pembelian Fixed Asset"} />
        <Paper className={classes.paper}>
          <RenderContent
            classes={classes}
            data={data}
            menu={menu}
            changeParentData={changeParentData}
          />
        </Paper>
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data, menu, changeParentData }) => {
  const [formBarang, setFormBarang] = useState(RESET_STATE_PEMBELIAN_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [listPembelian, setListPembelian] = useState([]);
  // const { setFormData } = useContext(FormContext);
  useEffect(() => {
    (async () => {
      await setNewDataPembelianList(data?.id);
    })();
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPembelianList = async (id) => {
    if (data?.length > 0) {
      const formLocal = localStorage.getItem(WMS_FA_PEMBELIAN);
      if (formLocal) {
        const pars = JSON.parse(formLocal);
        await getListPembelian(isNull(id) ? pars.id : id);
      } else {
        setListPembelian([]);
      }
    } else {
      await getListPembelian(id);
    }
  };

  const getListPembelian = async (id) => {
    if (id !== "" && id !== undefined) {
      const res = await getPembelianItemByPembelianId(id);
      if (res.state) {
        setListPembelian(res.data);
      } else {
        setListPembelian([]);
      }
    }
  };

  return (
    <>
      <FormPembelian
        listPembelian={listPembelian}
        setListPembelian={setListPembelian}
        setNewDataPembelianList={setNewDataPembelianList}
        menu={menu}
        changeParentData={changeParentData}
      />
      <div className="mt-2 mb-2">
        <hr />
      </div>
      <div className="mt-2">
        <RenderListPembelian
          classes={classes}
          formBarang={formBarang}
          listPembelian={listPembelian}
          setFormBarang={setFormBarang}
          showModalBarang={showModalBarang}
          setShowModalBarang={setShowModalBarang}
          getListPembelian={getListPembelian}
          setNewDataPembelianList={setNewDataPembelianList}
        />
      </div>
    </>
  );
};
